import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyField from '../fields/api-key-field/api-key-field';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import WebshipperCredentialsStore from '../../../../stores/credentials/shipping/webshipper-credentials-store';

interface IProps {
    credentialsStore: WebshipperCredentialsStore,
    vGroup: IValidationGroup,
    apiKeyLabel?: string,
    apiKeyNote?: string,
    apiSecretLabel?: string,
    apiSecretNote?: string,
    customerNumberLabel?: string,
    customerNumberNote?: string,
}

const WebshipperCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
            />
            <FormFieldLine
                required
                label='API user name'
                key='username'
                note='API username from your webshipper dashboard'
            >
                <Input
                    value={credentialsStore.username}
                    onChange={credentialsStore.setUsername}
                    validationGroup={vGroup}
                    type='password'
                    autoComplete='new-password'
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='Order channel id'
                key='order-channel-id'
                note='Order channel ID from your webshipper dashboard'
            >
                <Input
                    value={credentialsStore.orderChannelId}
                    onChange={credentialsStore.setOrderChannelId}
                    validationGroup={vGroup}
                    type='password'
                    autoComplete='new-password'
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default WebshipperCredentials;
